// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__34_SC","cell":"ColumnAccessor_cell__dVXjd","firstCellAccent":"ColumnAccessor_firstCellAccent__3wkOz"};